import styled from 'styled-components'

/**
 * Surface container for the grid: bordered, rounded, shadowed, overflow hidden.
 * `position: relative` anchors future overlays (selection bar) inside the panel.
 */
export const Panel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  direction: rtl;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.line};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadows.card};
  overflow: hidden;
`

export default Panel
